if (!customElements.get('upsell-products')) {
  customElements.define(
    'upsell-products',
    class UpsellProducts extends HTMLElement {
      constructor () {
        super();

        this.originalFetch = window.fetch.bind(window);
        this.blocks = [];

        if (!window.__upsellProductsFetchWrapped) {
          this.catchRequest();
          window.__upsellProductsFetchWrapped = true;
        }
      }

      connectedCallback () {
        this.collectBlocks();
      }

      collectBlocks () {
        this.blocks = Array.from(this.querySelectorAll('upsell-product')).map((block) => {
          const checkbox = block.querySelector('.mobileToggle');
          let params = null;

          const jsonEl = block.querySelector('[type="application/json"]');
          if (jsonEl) {
            try {
              params = JSON.parse(jsonEl.textContent);
            } catch (e) {
              console.error('upsell-product JSON parse error:', e.message);
            }
          }

          return {
            block,
            checkbox,
            params,
          };
        }).filter((item) => {
          return (
            item.checkbox &&
            item.params &&
            item.params.mainProduct &&
            item.params.upsellSelectedVariant &&
            item.params.upsellSelectedVariant.id
          );
        });
      }

      catchRequest () {
        const originalFetch = this.originalFetch;
        const self = this;

        window.fetch = function (input, init) {
          const url =
            typeof input === 'string'
              ? input
              : (input && input.url) || '';

          let method = 'GET';
          if (init && init.method) {
            method = init.method;
          } else if (input && typeof input === 'object' && input.method) {
            method = input.method;
          }

          const isCartAdd =
            !!url &&
            !!method &&
            method.toUpperCase() === 'POST' &&
            window.themeVariables &&
            window.themeVariables.routes &&
            window.themeVariables.routes.cart_add_url &&
            url.indexOf(window.themeVariables.routes.cart_add_url) !== -1;

          if (!isCartAdd) {
            return originalFetch(input, init);
          }

          const body = init && init.body;
          if (!(body instanceof FormData)) {
            return originalFetch(input, init);
          }

          const newData = self.prepareData(body);

          if (newData === null) {
            const productID = Number(body.get('product-id') || body.get('product_id'));

            const p = originalFetch(input, init);

            return p.then((response) => {
              const isMainProduct = self.blocks.find((item) => {
                return productID === item?.params?.mainProduct?.id;
              });
              if (isMainProduct) {
                self.syncQuantity();
              }
              return response;
            });
          }

          const formData = new FormData();
          for (let field in newData) {
            if (!Object.prototype.hasOwnProperty.call(newData, field)) continue;

            if (field === 'items') {
              newData.items.forEach((item, index) => {
                for (let itemField in item) {
                  if (!Object.prototype.hasOwnProperty.call(item, itemField)) continue;
                  formData.append(`items[${index}][${itemField}]`, item[itemField]);
                }
              });
            } else {
              formData.append(field, newData[field]);
            }
          }

          if (!init) init = {};
          init.body = formData;

          const p = originalFetch(input, init);

          return p.then((response) => {
            self.syncQuantity();
            return response;
          });
        };
      }


      syncQuantity () {

        try {
          if (
            window.__lsUpsellSync &&
            typeof window.__lsUpsellSync.sync === 'function'
          ) {
            window.__lsUpsellSync.sync();
          }
        } catch (e) {
          console.warn('[UpsellSync] response.clone() error:', e);
        }
      }
      prepareData (formData) {
        const variantID = Number(formData.get('id'));
        const productID = Number(formData.get('product-id') || formData.get('product_id'));
        const quantity = formData.get('quantity') === null ? 1 : Number(formData.get('quantity'));

        if (!productID || !variantID) {
          return null;
        }

        const properties = {};
        for (const [key, value] of formData.entries()) {
          if (key.startsWith('properties[') && key.endsWith(']')) {
            const propName = key.slice('properties['.length, -1);
            properties[propName] = value;
          }
        }

        const cartSections = {
          'section-id': formData.get('section-id'),
          'sections': formData.get('sections'),
          'sections_url': formData.get('sections_url'),
        };

        const extraFields = {};
        for (const [key, value] of formData.entries()) {
          if (
            key === 'id' ||
            key === 'product-id' ||
            key === 'product_id' ||
            key === 'quantity' ||
            key === 'section-id' ||
            key === 'sections' ||
            key === 'sections_url' ||
            key.startsWith('properties[')
          ) {
            continue;
          }

          extraFields[key] = value;
        }

        const mainItem = {
          id: variantID,
          quantity: quantity,
        };

        if (Object.keys(properties).length > 0) {
          mainItem.properties = properties;
        }

        const upsellItems = [];

        this.blocks.forEach(({ checkbox, params }) => {
          if (!checkbox.checked) return;

          if (params.mainProduct?.id === productID && params.upsellSelectedVariant?.id) {
            const upsellItem = {
              id: params.upsellSelectedVariant.id,
              quantity: mainItem.quantity,
            };
            upsellItem['properties[_ls_upsell_for_product_id]'] = String(productID);

            upsellItems.push(upsellItem);
          }
        });

        if (!upsellItems.length) {
          return null;
        }

        return {
          items: [
            mainItem,
            ...upsellItems,
          ],
          ...cartSections,
          ...extraFields,
        };
      }

    },
  );
}
